import { Card } from 'flowbite-react';
import React from 'react';
import p1 from '../../Media/card2/p1.jpg'
import p2 from '../../Media/card2/p2.jpg'
import p3 from '../../Media/card2/p3.jpg'
import p4 from '../../Media/card3/p4.webp'
import p5 from '../../Media/card3/p5.jpg'
import p6 from '../../Media/card3/p6.jpg'
import dp from '../../Media/dp.jpg'

const Section2 = () => {
    return (
        <div className='w-11/12 md:w-10/12 mx-auto mt-5'>
            <div className='md:flex justify-between'>

                <div className="max-w-sm mb-3 md:mb-0">
                    <Card imgSrc={p1}>
                        <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                            Racial Disparities in Metastatic Triple-Negative Breast Cancer
                        </h5>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                            Why Do Black Women Get Triple-Negative Breast Cancer More Often?
                        </p>
                    </Card>
                </div>
                <div className="max-w-sm mb-3 md:mb-0">
                    <Card imgSrc={p2}>
                        <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                            Racial Disparities in Metastatic Triple-Negative Breast Cancer
                        </h5>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                            Why Do Black Women Get Triple-Negative Breast Cancer More Often?
                        </p>
                    </Card>
                </div>
                <div className="max-w-sm mb-3 md:mb-0">
                    <Card imgSrc={p3}>
                        <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                            Racial Disparities in Metastatic Triple-Negative Breast Cancer
                        </h5>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                            Why Do Black Women Get Triple-Negative Breast Cancer More Often?
                        </p>
                    </Card>
                </div>

            </div>

            <div className='flex justify-between items-center text-primary-600 mt-8'>
                <h3 className='text-2xl font-bold my-2'>Trending Topics</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />
            <div className='flex flex-wrap my-5'>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>COVID Vaccine Booster</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Long COVID</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Body-Neutrality</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Disability Adjusted Life Years</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Period Underwear</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Epidural</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Phage Therapy</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Food Deserts</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Nonallergic Rhinitis</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-full mx-1 mb-2'>Digital Self-Harm</p>
            </div>

            <div className='flex justify-between items-center text-primary-600 mt-8'>
                <h3 className='text-2xl font-bold my-2'>Featured Stories</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />

            <div className='md:flex justify-between my-5'>

                <div className="max-w-sm mb-3 md:mb-0">
                    <Card imgSrc={p4}>
                        <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                            No, Robots Are Not Taking Over Health Care
                        </h5>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                            Concerned Artificial Intelligence will one day replace your doctor? Not so.
                        </p>
                    </Card>
                </div>
                <div className="max-w-sm mb-3 md:mb-0">
                    <Card imgSrc={p5}>
                        <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                            AI ‘Simulants’ Fast-Track New Drugs.
                        </h5>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                            Using data, creating new drugs may become faster, cheaper, and more efficient.
                        </p>
                    </Card>
                </div>
                <div className="max-w-sm mb-3 md:mb-0">
                    <Card imgSrc={p6}>
                        <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                            AI for Better Diversity, Inclusion in Clinical Trials?
                        </h5>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                            We’re not there yet, but technology could soon help eliminate human bias from trials.
                        </p>
                    </Card>
                </div>

            </div>

            <div className='flex justify-between items-center text-primary-600 mt-8'>
                <h3 className='text-2xl font-bold my-2'>Featured Stories</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />

            <div class="relative overflow-x-auto">
                <table class="w-full text-left">
                    <tbody>
                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    ADD/ADHD - Childhood
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    ADHD
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Allergies
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Alzheimer's
                                </div>
                            </td>
                        </tr>
                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Ankylosing Spondylitis
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Anxiety Disorders
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Arthritis
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Asthma
                                </div>
                            </td>
                        </tr>

                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Back Pain
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Cancer
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Children's Vaccines
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Cholesterol
                                </div>
                            </td>
                        </tr>


                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Cold, Flu, & Cough
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    COPD
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Coronavirus
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Depression
                                </div>
                            </td>
                        </tr>


                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Diabetes
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Digestive Disorders
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Eye Health
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Health & Balance
                                </div>
                            </td>
                        </tr>


                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Heart Health
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Heartburn/GERD
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Hypertension
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Lung Cancer
                                </div>
                            </td>
                        </tr>


                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Mental Health
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Migraines
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Multiple Myeloma
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Multiple Sclerosis
                                </div>
                            </td>
                        </tr>


                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Oral Care
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Orthopedics
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Osteoporosis
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Ovarian Cancer
                                </div>
                            </td>
                        </tr>


                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Prostate Cancer
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Psoriasis
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Rheumatoid Arthritis
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Schizophrenia
                                </div>
                            </td>
                        </tr>


                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Sexual Conditions
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Skin Problems
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Sleep Disorders
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Zoonosis
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className='md:flex items-center my-5 md:my-10'>
                <img className='md:w-[605px]' src={dp} alt="" />
                <div className='md:mt-0 mt-3 md:px-5 '>
                    <h3 className='text-2xl md:text-4xl font-bold tracking-tight text-primary-600'>Our Content Is Different Because We Set the Bar Higher</h3>
                    <p className='text-lg mt-2 text-gray-600'>As a leader in digital health publishing for more than 25 years, WebMD strives to maintain the most comprehensive and reliable source of health and medical information on the internet. We recognize the responsibility that comes along with being the most well-known and trusted health information platform — and we take that responsibility seriously by:</p>
                    <br />
                    <p className='text-lg text-gray-600'>1. Charging our content creators to practice journalistic principles of excellence and provide objective, accurate, and balanced reporting</p>
                    <br />
                    <p className='text-lg text-gray-600'>2. Maintaining editorial independence and transparency into how we protect the integrity of our content</p>
                    <br />
                    <p className='text-lg text-gray-600'>3. Regularly reviewing and updating our content by working with our network of more than 100 doctors and health experts</p>
                    <div className='flex items-center whitespace-nowrap text-primary-600 mt-3'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                            <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                        </svg>
                        Learn more about our Editorial Process
                    </div>
                </div>
            </div>

            <div className='flex justify-between items-center text-primary-600 mt-8'>
                <h3 className='text-2xl font-bold my-2'>Health Solutions</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />

            <div className='flex flex-wrap my-5'>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>Top CBD Gummies</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>Chronic Pain Relief</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>CBD, Sleep, Relaxation</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>What is CBD?</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>Stem Cell Transplants</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>Bipolar Depression</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>Dental Implants</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>Reduced Recurrence Risk</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>Advanced Lung Cancer</p>
                <p className='text-lg px-3 py-1 bg-orange-200 rounded-lg mx-1 mb-2'>ABCDE Melanoma Rule</p>
            </div>


            <div className='flex justify-between items-center text-primary-600 mt-8'>
                <h3 className='text-2xl font-bold my-2'>More From WebMD</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />

            <div className='flex flex-wrap mt-5 mb-28'>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>The Emotional Toll of RRMM</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>What You Need in Your Migraine Kit</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>What’s Traveling Like With PsA?</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Advancements in Treating PsA</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Relationships and Migraines</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>How to Identify Bad Eating Habits</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Successfully Managing PD</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Don't Let DR Take Your Vision</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Expert Insights Into AS Treatment</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Life With Early-Stage Breast Cancer</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Product Tips for Eczema Patients</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>HCM: How Is It Diagnosed?</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>What Is Idiopathic Hypersomnia?</p>
                <p className='text-lg px-3 py-1 bg-teal-200 rounded-lg mx-1 mb-2'>Talk to Doc Treat Late-Stage NSCLC</p>
            </div>
        </div>
    );
};

export default Section2;